// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> mox-theme-prestige -> one-two-two-one-broadway-lofts
// Generated: 2026-11-03T22:38:18.364Z
// Counts: 4 design, 14 content, 3 slot group, 0 collection binding, 7 section, 16 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#070a0b",
    "mappedField": null
  },
  "design._site.color.secondary": {
    "cssVariable": "--vibe-color-secondary",
    "overrideType": "VALUE",
    "value": "#b4af2d",
    "mappedField": null
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162466/01a01059-a5e2-7667-9dee-e75a334c3f2a.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqlist.footer_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Still have questions?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Amenity spaces with real range.</strong> Start above it all at the rooftop pool, where skyline views make an easy backdrop for a quiet reset or a sunny afternoon. Closer to ground level, the courtyard trades city energy for greenery, flowers, and hanging plants, while five landscaped courtyards and BBQ areas give you more room to unwind outdoors.</p><p>Inside, the loft experience stays just as distinctive: 10'5\" ceilings, diamond-polished concrete floors, commercial-grade windows, and granite countertops create a clean industrial canvas. Select homes add floor-to-ceiling glass, Juliette or extended balconies, street-access entrances, and downtown or Riverwalk views. With 24-hour cardio, open-air Olympic lifting and boxing, garage parking, EV charging, and a package center, 1221 Broadway Lofts brings everyday convenience and standout design into one connected Downtown address. See more in the <a class=\"richtext-link\" href=\"/gallery\">amenity gallery</a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "layoutoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>PET-FRIENDLY <span data-type=\"field-token\" data-field=\"property_address_city\"></span> APARTMENTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Room to roam, right at home.</strong></p><p>At 1221 Broadway Lofts, pets aren’t just welcome—they’re part of the community. We proudly welcome <strong>dogs and cats of all breeds and sizes, with no breed restrictions or weight limits</strong>, so you can find a home that works for your whole household.</p><p>Let your pup stretch their legs at our <strong>on-site fenced dog park</strong>, take a stroll through the community, or head out for a leashed walk along the nearby River Walk trails. At home, polished concrete floors and in-unit laundry make everyday pet life a little easier, while oversized windows give cats the perfect perch for watching the world go by.</p><p>And if you’re giving a local shelter pet a forever home, we’d love to celebrate with you. <strong>Adopt your dog or cat from a local animal shelter, provide your adoption paperwork, and we’ll waive your pet deposit.</strong></p><p>Because at 1221 Broadway Lofts, there’s room for every member of your family—including the four-legged ones.</p><p><a class=\"richtext-link\" href=\"/amenities\">Explore our pet-friendly amenities</a> or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> and see why your next home is one your pet will love, too.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We believe in supporting local animal shelters. When you adopt your dog or cat from a local animal shelter and provide adoption paperwork, we’ll waive your pet deposit. Bring your new best friend home and enjoy a community where pets are welcome!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 12pt;\">We welcome dogs and cats of all breeds and sizes, with no breed restrictions or weight limits.</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.HeroSolidBG": {
    "properties": {
      "opacity": "1"
    }
  },
  "featuring/rooftop-pool-apartments-downtown-san-antonio::_section.HyperlocalHero": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "accessibility-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "amenities-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "apply-now-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "contact-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "floor-plans-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "gallery-hero.bg_image": {
    "properties": {
      "opacity": "0.5"
    }
  },
  "interactive-map-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "lifestyle-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "neighborhood-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "pet-policy-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "privacy-policy-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "resident-access-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "schedule-tour-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  },
  "virtual-tour-hero.bg_image": {
    "properties": {
      "opacity": "0.55"
    }
  }
};
